import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReportComponent } from './report.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule
  ],
  declarations: [ReportComponent],
  exports: [
    ReportComponent
  ],
  providers: [
  ]
})
export class ReportModule { }
